// class to hold reference to the paramcodes used for the hydrograph 
// these values drive whether the gauge is a stage or flow gauge
export class Paramcodes {
  static STAGE_CODES = ['00065', '0065'];
  static FLOW_CODES = ['00060', '0060'];
}